module.exports = __webpack_public_path__ + "img/rg-10.prt.050db514.jpg";